// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7zmx8","colMin":"styles_colMin__zwbcW"};